import React from 'react';
import StockByLocationFunctional from './components/stock-by-location-list-functional';
import './stock-by-location.scss';

const StockByLocation = () => {
	return <StockByLocationFunctional />;
};

export default StockByLocation;
